<!-- components/GaugeSemi.vue -->
<template>
  <div class="inline-flex flex-col items-center">
    <div v-if="title" class="text-sm text-slate-500 mb-1">{{ title }}</div>

    <svg :width="size" :height="size/2" viewBox="0 0 200 100" class="overflow-visible">
      <!-- Pista -->
      <path
        d="M10 100 A90 90 0 0 1 190 100"
        fill="none"
        :stroke="bgColor"
        :stroke-width="stroke"
        stroke-linecap="butt"
        pathLength="100"
      />
      <!-- Progreso -->
      <path
        d="M10 100 A90 90 0 0 1 190 100"
        fill="none"
        :stroke="getColorByPercent(value)"
        :stroke-width="stroke"
        stroke-linecap="butt"
        pathLength="100"
        :stroke-dasharray="`${clamped} 100`"
      />

      <!-- Aguja/muesca: línea corta radial SOBRE el arco -->
      <line
        :x1="needleInner.x" :y1="needleInner.y"
        :x2="needleOuter.x" :y2="needleOuter.y"
        :stroke="needleColor"
        :stroke-width="needleStroke"
        stroke-linecap="round"
        style="shape-rendering:geometricPrecision"
      />
      <line
        :x1="100" :y1="-5"
        :x2="100" :y2="36"
        stroke="#fff"
        stroke-width="2px"
        stroke-linecap="round"
        style="shape-rendering:geometricPrecision"
      />

      <!-- % -->
      <text x="100" y="78" text-anchor="middle"
            class="font-semibold" :fill="percentColor" style="font-size:16px">
        {{ clamped }}%
      </text>
    </svg>

    <div :class="['mt-1 font-semibold', labelClass]">{{ label }}</div>
  </div>
</template>

<script>
import MixinIAReputation from "@/mixins/iareputation.js"

const cx = 100, cy = 100, radius = 90
export default {
  mixins: [MixinIAReputation],
  props: {
    value: { type: Number, required: true },     // 0..100
    title: { type: String, default: '' },
    label: { type: String, default: '' },
    size:  { type: Number, default: 220 },
    stroke:{ type: Number, default: 32 },        // grosor de la barra
    color: { type: String, default: '#fb6a3a' }, // color de progreso
    bgColor: { type: String, default: '#eff3f8' },
    needleColor: { type: String, default: '#6b7280' },

    /* Aguja más “ancha” que la barra: la línea cruza el arco con overshoot */
    needleStroke: { type: Number, default: 4 },  // grosor visual de la aguja
    overshootIn:  { type: Number, default: 3 },  // cuánto entra hacia el centro (px)
    overshootOut: { type: Number, default: 5 },  // cuánto sale hacia fuera (px)

    percentColor: { type: String, default: '#111827' },
  },
  computed: {
    clamped(){
     return Math.max(0, Math.min(100, Math.round(this.value)))
    },
    angleDeg() {
      return 180 + (this.clamped / 100) * 180
    },
    angleRad() {
      return this.angleDeg * Math.PI / 180
    },
    cosA() {
      return Math.cos(this.angleRad)
    },
    sinA() {
      return Math.sin(this.angleRad)
    },
    needleInner(){
      const r = radius - this.stroke / 2 - this.overshootIn
      return { x: cx + r * this.cosA, y: cy + r * this.sinA }
    },
    needleOuter(){
      const r = radius + this.stroke / 2 + this.overshootOut
      return { x: cx + r * this.cosA, y: cy + r * this.sinA }
    },
    labelClass(){
      if (this.clamped < 40)  return 'text-orange-500'
      if (this.clamped < 70)  return 'text-amber-500'
      return 'text-emerald-600'
    }
  }
}




</script>
